// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAxDQsI_dDW4xWcQJ5MbON0FAjQ_Z-8Thg",
    authDomain: "produvar-paramat.firebaseapp.com",
    databaseURL: "https://produvar-paramat.firebaseio.com",
    projectId: "produvar-paramat",
    storageBucket: "produvar-paramat.appspot.com",
    messagingSenderId: "139857823947"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
